import React from 'react';
import PropTypes from 'prop-types';

import { Link, useLocation } from 'react-router-dom';
import Messages from 'components/organisms/Messages';
import SuperAdminMessages from 'components/organisms/SuperAdmin/Messages';

import { Wrapper, Item } from './styled';
import { useUser } from '../../../redux/user/use-user';

const Breadcrumbs = ({ items }) => {
  const { pathname } = useLocation();
  const { isSuperAdmin } = useUser();
  const showMessageDialog = pathname === '/';
  return (
    <Wrapper main={true}>
      <Wrapper>
        {items.map((i, index) => (
          <Item key={index}><Link to={i.link}>{i.label}</Link></Item>
        ))}
      </Wrapper>
      {!isSuperAdmin && showMessageDialog && (
        <Wrapper>
          <Messages />
        </Wrapper>
      )}
      {isSuperAdmin && (
        <Wrapper>
          <SuperAdminMessages />
        </Wrapper>
      )}
    </Wrapper>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.array,
};

export default Breadcrumbs;
